import { render, staticRenderFns } from "./document-status-select.vue?vue&type=template&id=a269512e"
import script from "./document-status-select.vue?vue&type=script&lang=js"
export * from "./document-status-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports